<template>
    <CCard>
        <CCardBody>
            <a :href="item.url" target="_blank">
                <img :src="item.path" style="height: 100%; width: 100%; object-fit: cover;"/>
            </a>
        </CCardBody>
    </CCard>
</template>

<script>

export default {
    name: "ProviderItem",
    props: ['item'],
}
</script>
